let cached: { gvl: unknown; maxVendorId: number } | null = null;

export async function loadPinnedGvl(url: string) {
  if (cached) return cached;
  const res = await fetch(url, { cache: 'reload' });
  if (!res.ok) throw new Error(`GVL fetch failed: ${res.status}`);
  const gvl = await res.json();
  const vendorsRecord =
    gvl &&
    typeof gvl === 'object' &&
    (gvl as Record<string, unknown>).vendors &&
    typeof (gvl as Record<string, unknown>).vendors === 'object'
      ? (gvl as { vendors: Record<string, { id?: number }> }).vendors
      : {};
  const vendors = Object.values(vendorsRecord);
  const maxVendorId = vendors.reduce(
    (m: number, v: { id?: number }) => Math.max(m, v?.id || 0),
    64,
  );
  cached = { gvl, maxVendorId };
  return cached;
}
